import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { FbSqUser, getFbSqUser } from 'slices/SqUserSlice';
import { AppThunk, RootState } from 'slices/store';

export enum ModalKind {
  ShowGameOverModal = 'showGameOverModal',
  ShowJoinGameModal = 'showJoinGameModal',
  ShowPlayerModal = 'showPlayerModal',
  ShowScoringBreakdownModal = 'showScoringBreakdownModal',
  ShowScoreManager = 'showScoreManager',
  ShowScoreManagerCf = 'showScoreManagerCf',
  ShowSelectNumPicksModal = 'showSelectNumPicksModal',
  ShowUserSettingsModal = 'showUserSettingsModal',
  ShowAdminModal = 'showAdminModal',
}

export type SqModalProps = {
  showGameOverModal: boolean;
  showJoinGameModal: boolean;
  showPlayerModal: boolean;
  showScoringBreakdownModal: boolean;
  showScoreManager: boolean;
  showScoreManagerCf: boolean;
  showSelectNumPicksModal: boolean;
  showUserSettingsModal: boolean;
  showAdminModal: boolean;
};

export type SetModalPayload = {
  kind: ModalKind;
  isVisible: boolean;
};

const initialState: SqModalProps = {
  showGameOverModal: false,
  showJoinGameModal: false,
  showPlayerModal: false,
  showScoringBreakdownModal: false,
  showScoreManager: false,
  showScoreManagerCf: false,
  showSelectNumPicksModal: false,
  showUserSettingsModal: false,
  showAdminModal: false,
};

// #region ACTIVE GAME ACTIONS ************************************************

export const doShowModal =
  (kind: ModalKind, isVisible = true): AppThunk =>
  (dispatch) => {
    dispatch(setModal({ kind, isVisible }));
  };

export const doHideModal =
  (kind: ModalKind, isVisible = false): AppThunk =>
  (dispatch) => {
    dispatch(setModal({ kind, isVisible }));
  };

export const sqModalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<SetModalPayload>) => {
      state[action.payload.kind] = action.payload.isVisible;
    },

    // RESET ******************************************************************
    resetModals: () => {
      return { ...initialState };
    },
  },
});

export const { setModal, resetModals } = sqModalSlice.actions;

export const getShowJoinGameModal = (state: RootState): boolean => state.ui.modal.showJoinGameModal;
export const getShowGameOverModal = (state: RootState): boolean => state.ui.modal.showGameOverModal;
export const getShowPlayerModal = (state: RootState): boolean => state.ui.modal.showPlayerModal;
export const getShowScoreManagerModal = (state: RootState): boolean => state.ui.modal.showScoreManager;
export const getShowScoreManagerCfModal = (state: RootState): boolean => state.ui.modal.showScoreManagerCf;
export const getShowScoringBreakdownModal = (state: RootState): boolean => state.ui.modal.showScoringBreakdownModal;
export const getShowSelectNumPicksModal = (state: RootState): boolean => state.ui.modal.showSelectNumPicksModal;
export const getShowUserSettingsModal = (state: RootState): boolean => state.ui.modal.showUserSettingsModal;
export const getShowAdminModal = (state: RootState): boolean => state.ui.modal.showAdminModal;

export const getModal = (state: RootState, kind: ModalKind): boolean => {
  switch (kind) {
    case ModalKind.ShowGameOverModal:
      return state.ui.modal.showGameOverModal;
    case ModalKind.ShowScoringBreakdownModal:
      return state.ui.modal.showScoringBreakdownModal;
    case ModalKind.ShowJoinGameModal:
      return state.ui.modal.showJoinGameModal;
    case ModalKind.ShowSelectNumPicksModal:
      return state.ui.modal.showSelectNumPicksModal;
    case ModalKind.ShowUserSettingsModal:
      return state.ui.modal.showUserSettingsModal;
    case ModalKind.ShowPlayerModal:
      return state.ui.modal.showPlayerModal;
    case ModalKind.ShowScoreManager:
      return state.ui.modal.showScoreManager;
    case ModalKind.ShowScoreManagerCf:
      return state.ui.modal.showScoreManagerCf;
    case ModalKind.ShowAdminModal:
      return state.ui.modal.showAdminModal;
    default:
      return false;
  }
};
export default sqModalSlice.reducer;
